import { render } from "./CIS-PageTitle.vue?vue&type=template&id=5aa8c37c"
import script from "./CIS-PageTitle.vue?vue&type=script&lang=js"
export * from "./CIS-PageTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__